'use strict'

import moment from 'moment'
import { validateLatLng } from '@/helpers/general'

import { state as state$ } from './admin/Map/state'
import { mutations as mutations$ } from './admin/Map/mutations'

export const state = {
  ...state$,
  isLoadingTrips: false,
  loading: {
    trips: false,
    waypoints: false,
    directions: false
  },
  showMap: false,
  mapObject: null,
  marker: null,
  bounds: null,
  tripCount: 0,
  devices: [],
  trips: [],
  markers: [],
  entity: null,
  entities: [],
  waypoints: [],
  selectedMarker: null,
  multipleTripsLoading: false,
  selectedMarkerActive: false,
  activeTrip: null,
  showActiveTrip: false,
  activeTrips: [],
  selectedDeviceDrawer: false,
  unsubscribe: null,
  infoWindow: {
    position: {
      lat: 0,
      lng: 0
    },
    open: false,
    template: {}
  },
  message: {}
}

export const mutations = {
  ...mutations$,

  findEntity (state, { id, isMissing, axios }) {
    if (id === undefined) return

    const path = isMissing
      ? `missing/${id}`
      : `entities/${id}?with=tags`

    axios.get(path)
      .then(response => {
        const data = isMissing
          ? { ...response.data.data.entity, case: response.data.data.case, trips: response.data.data.trips }
          : { ...response.data.data }

        if (data.odo === null) data.odo = 0

        state.drawer.entity = {
          ...data,
          loading: false
        }
      })
      .catch(e => {
        state.drawer.entity = {
          error: e,
          loading: false
        }
      })
  },

  setMessage (state, { message }) {
    state.message = message
  },

  setMarkers (state, { markers }) {
    state.markers = markers
  },

  resetMap (state) {
    state.markers = []
  },

  setShowMap (state, { show }) {
    state.showMap = show
  },

  appendTrips (state, { trips }) {
    trips.forEach(trip => {
      state.trips.push(trip)
    })
  },

  setMapBounds (state, { bounds }) {
    if (bounds) {
      state.bounds = bounds
    } else {
      state.bounds = null
    }
  },

  updateDevice (state, { device }) {
    state.devices = Object.assign({}, state.devices, device)
  },

  setMarker (state, { marker }) {
    let mute = null
    state.selectedDeviceDrawer = false

    mute = setTimeout(() => {
      state.marker = marker
      state.selectedMarker = marker
      state.selectedDeviceDrawer = true
    }, 500)

    mute = null
  },

  updateMarker (state, { marker }) {
    state.markers = state.markers.map(m => {
      if (m.imei === marker.imei) {
        return marker
      }

      return m
    })
  },

  modifyMarker (state, { marker }) {
    const { markers } = state
    const markerIds = markers.map(marker => marker.entityId)
    const index = markerIds.indexOf(marker.entityId)

    state.markers = markers.map((value, key) => key === index ? marker : value)
  },

  removeMarker (state, { marker }) {
    state.markers = state.markers.filter(m => {
      return m.entityId !== marker.entityId
    })
  },

  resetMarkers (state) {
    state.markers = []
  },

  resetMarker (state) {
    state.infoWinOpen = false
    state.selectedDeviceDrawer = false
    state.entity = null
    state.marker = null
    state.visibleMarkers = state.markers
    state.trips = {}
    state.activeTrips = []
    state.selectedMarker = null
  },

  toggleSelectedMarkerActive (state) {
    state.selectedMarkerActive = !state.selectedMarkerActive
  },

  setSelectedMarkerActive (state, { active }) {
    state.selectedMarkerActive = active
  },

  hideDirections (state) {
    state.activeTrips = []
    state.showActiveTrip = false
  },

  actualWaypoints (state, { waypoints }) {
    state.waypoints = []
    waypoints.forEach(waypoint => {
      if (validateLatLng(waypoint)) {
        state.waypoints.push(new google.maps.LatLng(waypoint.position))
      }
    })
  },

  setLoading (state, { waypoints, trips, directions }) {
    state.loading.directions = directions || false
    state.loading.trips = trips || false
    state.loading.waypoints = waypoints || false
  },

  setMultipleTripsLoading (state, { loading }) {
    state.multipleTripsLoading = loading
  },

  resetShowTrips (state) {
    state.activeTrips = []
    state.showActiveTrip = false
  },

  setInfoWindow (state, { opened, content, markerIndex, position }) {
    const original = state.infoWindow
    state.infoWindow = Object.assign({}, original,
      { opened, content, markerIndex, position }
    )
  },

  resetDevice (state) {
    state.activeTrips = []
    state.showActiveTrip = false
    state.showDirections = false
    state.device = null
  },

  /**
   *  Get Entities from state with getter.
   *
   *  @param state.entities
   */
  setEntities (state, { entities }) {
    state.entities = entities
  },

  setEntity: (state, { entity }) => {
    state.entity = entity
  },

  resetEntity: (state) => {
    state.entity = null
  },

  resetEntities: (state) => {
    state.entities = []
  },

  setVisibleMarkers (state, { visibleMarkers }) {
    state.visibleMarkers = visibleMarkers
  },

  setSearchResults (state, { markers }) {
    state.searchResults = markers
  },

  setPendingWaypoints (state, { pending }) {
    state.pendingWaypoints = pending
  },

  setSelectedDeviceDrawer (state, { selectedDeviceDrawer }) {
    state.selectedDeviceDrawer = selectedDeviceDrawer
    state.showDirections = selectedDeviceDrawer
  },

  updateSelectedMarker (state, { marker }) {
    state.selectedMarker = marker
  },

  resetSelectedMarker (state) {
    state.selectedMarker = null
  },

  setWaypoints (state, { waypoints }) {
    state.waypoints = waypoints
  },

  /**
   *  Get Unsubscribe from state with getter.
   *
   *  @param state.unsubscribe
   */
  setUnsubscribe (state, { listener }) {
    state.unsubscribe = listener
  },

  resetMapView (state) {
    state.showMap = false
    state.mapObject = null
    state.marker = null
    state.trips = []
    state.devices = []
    state.markers = []
    state.entities = []
    state.waypoints = []
  },

  openInfoWindow (state, { marker }) {
    state.infoWindow = {
      position: marker.position,
      open: true,
      template: {
        title: marker.label,
        last_seen: moment.utc(marker.last_activity).fromNow()
      }
    }
  }
}

export const actions = {
  updateMarkerPosition ({ state, commit }, { imei, position }) {
    const marker = { ...state.markers.find(marker => marker.imei === imei) }
    if (!marker) {
      return null
    }

    console.log('location updated', imei)
    marker.position = position
    marker.last_activity = moment.now()
    commit('updateMarker', { marker })

    if (state.selectedMarker && state.selectedMarker.imei === marker.imei) {
      commit('updateSelectedMarker', { marker })
    }

    return marker
  },

  getEntity ({ rootState, commit }, { id }) {
    let entityRef
    entityRef = rootState.db.doc('entities/' + id)
    entityRef.get().then(snapshot => {
      if (snapshot.data()) {
        commit('setEntity', { entity: snapshot.data() })
      }
    })
  },

  getTripWaypoints ({ rootState, commit }, { trip }) {
    commit('resetShowTrips')

    commit('setLoading', {
      waypoints: true,
      directions: false,
      trips: false
    })

    let waypoints = []
    const colors = [
      '#fd7e14'
    ]

    const waypointRef = rootState.db.collection('waypoints')
    if (trip) {
      waypointRef.where('trip_id', '==', trip.id)
        .orderBy('positioned_at')
        .get()
        .then(snapshot => {
          const color = colors[0]
          waypoints = snapshot.docs.map((doc, key) => {
            const wp = doc.data()
            const size = doc.size
            const latLng = {
              lat: parseFloat(wp.latitude),
              lng: parseFloat(wp.longitude)
            }
            const isStart = (key === 0)
            const isEnd = (key === size - 1)

            if (validateLatLng(latLng)) {
              return {
                id: wp.id,
                waypoint: { ...wp },
                trip: { ...trip },
                position: latLng,
                startPoint: isStart,
                endPoint: isEnd,
                positioned_at: wp.positioned_at
              }
            }
          })
          commit('setWaypoints', { waypoints })
          commit('showTrip', { trip, waypoints, color })
        }).then(() => {
          commit('setLoading', {
            waypoints: false,
            directions: false,
            trips: false
          })
        })
    }
  },

  async getMultipleTrips ({ rootState, commit }, { tripsPerDay }) {

  },

  async getTripsForEntity ({ rootState, commit, state }, { perPage }) {
    if (!state.entity) {
      console.error('Entity not defined!')
      return
    }

    rootState.db
      .collection('trips')
      .orderBy('trip_started_at', 'desc')
      .where('deleted_at', '==', null)
      .where('entity_id', '==', state.entity.id)
      .limit(perPage)
      .get()
      .then(result => commit('setTrips', { trips: result.docs }))
  },

  async getNextTrips ({ rootState, commit, state }, { last, perPage }) {
    console.log(last, perPage)
    if (!state.entity) {
      console.error('Entity not defined!')
      return
    }

    rootState.db
      .collection('trips')
      .orderBy('trip_started_at', 'desc')
      .where('deleted_at', '==', null)
      .where('entity_id', '==', state.entity.id)
      .startAt(last.trip_started_at)
      .limit(perPage)
      .get()
      .then(result => commit('appendTrips', { trips: result.docs }))
  },

  resetMapView ({ commit }) {
    commit('resetMapView')
  },

  toggleMarker ({ state, commit }, { marker, selectedMarker }) {
    let response = 'set'
    if (selectedMarker && marker) {
      if (marker.imei === selectedMarker.imei) {
        commit('resetShowTrips')
        commit('resetMarker')
        commit('setSelectedMarkerActive', { active: false })

        response = 'reset'
      }
      if (marker.imei !== selectedMarker.imei) {
        commit('setSelectedMarkerActive', { active: true })
        commit('setMarker', { marker })
      }
    } else {
      commit('setSelectedMarkerActive', { active: true })
      commit('setMarker', { marker })
    }

    return response
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
